import React from 'react';
import { Helmet } from 'react-helmet-async';
import memLogo from '../MEM-Logo.jpeg';

export default function FaviconHead() {
  return (
    <Helmet>
      <link rel="icon" type="image/jpeg" href={memLogo} />
      <link rel="apple-touch-icon" href={memLogo} />
    </Helmet>
  );
}

